var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 43C33.598 43 43 33.598 43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43Z",
    stroke: "#F2F2F2",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5045 18.4131H16.4026V31.9987H12.5045V18.4131ZM14.3542 16.7138H14.326C12.9149 16.7138 12 15.6752 12 14.3601C12 13.0181 12.9419 12 14.3812 12C15.8194 12 16.7037 13.0155 16.7319 14.3563C16.7319 15.6714 15.8194 16.7138 14.3542 16.7138ZM32 32H27.5797V24.9684C27.5797 23.1282 26.8883 21.8732 25.3678 21.8732C24.2048 21.8732 23.5581 22.7197 23.2571 23.538C23.1442 23.8299 23.1618 24.2384 23.1618 24.6482V32H18.7827C18.7827 32 18.8391 19.5451 18.7827 18.4131H23.1618V20.5453C23.4205 19.613 24.8198 18.2825 27.0529 18.2825C29.8234 18.2825 32 20.2379 32 24.4446V32Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnIcon);
export default __webpack_public_path__ + "static/media/ln-icon.2842ed39065f5b1fb618c06d290ccf23.svg";
export { ForwardRef as ReactComponent };